import { useMutation } from '@tanstack/react-query';
import { updateSmartList } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';
import { UpdateSmartList } from 'shared/types/smart-list';

export type UpdateSmartListVariables = {
  uid: ID;
  smartList: UpdateSmartList;
};

export const useUpdateSmartListMutation = () =>
  useMutation({
    mutationFn: ({ uid, smartList }: UpdateSmartListVariables) =>
      updateSmartList(uid, smartList),
  });
